import { RefObject, useLayoutEffect, useState, useCallback } from 'react';

export const useBoundingClientRect = (element: RefObject<HTMLElement>) => {
    const [boundingClientRectState, setBoundingClientRectState] = useState<DOMRectReadOnly>();

    const calculateBoundingClientRect = useCallback(() => {
        if (element.current) {
            const observer = new IntersectionObserver((entries) => {
                setBoundingClientRectState(entries[0]?.boundingClientRect);
                observer.disconnect();
            });

            observer.observe(element.current);
        }
    }, [element]);

    useLayoutEffect(() => {
        calculateBoundingClientRect();
    }, [calculateBoundingClientRect]);

    return {
        boundingClientRectState,
        recalculateBoundingClientRect: calculateBoundingClientRect,
    };
};
